<template>
  <div class="selectListComponent" id="fieledSelectComponent" :style="position == 'right'?'right:0':'left:0'">
    <h2 class="title">名单列表</h2>
    <div class="closeBtn" @click="close">
      <i class="el-icon-close fr"></i>
    </div>
    <section class="search-box">
      <el-input v-model="keywords" placeholder="请输入关键字">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
      <div class="infinite-list" v-if="list.length > 0" style="margin-top: 10px">
        <div v-for="(item, index) in list" :key="index" @click="selectItem(item)" class="infinite-list-item">
          <div>{{item.listTitle}} <span class="nameEn">{{item.listName}}</span> <span class="primaryC">{{item.list}}</span></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: ['position', 'endValue'],
  data() {
    return {
      keywords: '', list: []
    }
  },
  created() {
    this.request({
      method: 'get', params: { workspaceId: this.utils.getSpaceInfo().id, keyword: this.keywords }, url: '/admin/datalist/options'
    }).then(res => {
      console.log(res)
      if (res.code == 200) {
        this.list = res.data
      }
    })
  },
  methods: {
    close() {
      this.$emit('update:rosterShow1', false)
      this.$emit('update:rosterShow2', false)
    },
    selectItem(item) {
      console.log(item)
      this.close()
      this.$emit('update:listTitle', item.listTitle)
      this.$emit('update:listName', item.listName)
      this.$emit('update:list', item.list.split(','))
    },
  }
}
</script>











<style scoped>
h2.title {
  display: inline-block; margin: 0;
}
.search-box {
  margin-top: 20px;
}
</style>

<style lang="scss">
@import "./style.scss";
.selectListComponent{
  .nameEn{
    color: #888;
    font-size: 12px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/FieldSelect/rosterField.vue